import { Container, Graphics } from 'pixi.js';
import { GAME_CONFIG, COLORS } from '../configs';
export class Road extends Container {
  private roadSurface: Graphics;
  private laneDividers: Graphics[] = [];
  private roadEdges: Graphics[] = [];
  constructor() {
    super();
    const roadWidth = GAME_CONFIG.roadWidth + 60;
    const roadHeight = 800;
    // Main road surface (asphalt)
    this.roadSurface = new Graphics();
    this.roadSurface.fill(0x1f2937);
    this.roadSurface.rect(-roadWidth / 2, -200, roadWidth, roadHeight + 400);
    this.roadSurface.fill();
    // Subtle asphalt texture using darker stripes
    this.roadSurface.fill({ color: 0x111827, alpha: 0.35 });
    this.roadSurface.rect(-roadWidth / 2, -200, roadWidth, 4);
    this.roadSurface.fill();
    this.roadSurface.fill({ color: 0x111827, alpha: 0.35 });
    this.roadSurface.rect(-roadWidth / 2, 0, roadWidth, 4);
    this.roadSurface.fill();
    this.roadSurface.fill({ color: 0x111827, alpha: 0.35 });
    this.roadSurface.rect(-roadWidth / 2, 200, roadWidth, 4);
    this.roadSurface.fill();
    this.roadSurface.fill({ color: 0x111827, alpha: 0.35 });
    this.roadSurface.rect(-roadWidth / 2, 400, roadWidth, 4);
    this.roadSurface.fill();
    this.roadSurface.fill({ color: 0x111827, alpha: 0.35 });
    this.roadSurface.rect(-roadWidth / 2, 600, roadWidth, 4);
    this.roadSurface.fill();
    this.addChild(this.roadSurface);
    // Left edge / curb
    const edgeLeft = new Graphics();
    edgeLeft.fill(0x4b5563);
    edgeLeft.rect(-roadWidth / 2 - 12, -200, 12, roadHeight + 400);
    edgeLeft.fill();
    edgeLeft.fill(0xfbbf24);
    edgeLeft.rect(-roadWidth / 2 - 12, -200, 4, roadHeight + 400);
    edgeLeft.fill();
    this.roadEdges.push(edgeLeft);
    this.addChild(edgeLeft);
    // Right edge / curb
    const edgeRight = new Graphics();
    edgeRight.fill(0x4b5563);
    edgeRight.rect(roadWidth / 2, -200, 12, roadHeight + 400);
    edgeRight.fill();
    edgeRight.fill(0xfbbf24);
    edgeRight.rect(roadWidth / 2 + 8, -200, 4, roadHeight + 400);
    edgeRight.fill();
    this.roadEdges.push(edgeRight);
    this.addChild(edgeRight);
    // Lane dividers (dashed lines between lanes)
    for (let i = 0; i < GAME_CONFIG.lanes - 1; i++) {
      const divider = new Graphics();
      const x = (i - (GAME_CONFIG.lanes - 2) / 2) * GAME_CONFIG.laneWidth;
      for (let j = -3; j < 10; j++) {
        divider.fill(COLORS.roadLine);
        divider.rect(x - 3, j * 80, 6, 40);
        divider.fill();
      }
      this.addChild(divider);
      this.laneDividers.push(divider);
    }
  }
  update(delta: number, speed: number): void {
    for (const divider of this.laneDividers) {
      divider.y += speed * delta;
      if (divider.y > 80) {
        divider.y -= 80;
      }
    }
  }
}